// extracted by mini-css-extract-plugin
export default {"icon":"inputCustomStyle_icon__F6Gvf","textInfo":"inputCustomStyle_textInfo__yNLKw"};